import { Trans } from '@lingui/react/macro';

import Stack from '@/design_system/Stack';
import Paragraph from '@/design_system/Typography/Paragraph';
import { Company } from '@/models/company';
import { getCountryName } from '@/utils/country';
import { formatCurrency } from '@/utils/number';

type InvoiceData = NonNullable<Company['invoiceData']>;

export const InvoiceDataCell = ({ invoiceData }: { invoiceData: InvoiceData }) => {
  const { address } = invoiceData;
  const addressLines = [
    address.line1,
    address.line2,
    [address.zipCode, address.city].filter(Boolean).join(' '),
    address.state,
    getCountryName(address.country) ?? address.country,
  ].filter(Boolean);

  return (
    <Stack gap="0.25rem">
      <Paragraph size="200">{invoiceData.name}</Paragraph>
      {invoiceData.id && (
        <Paragraph size="200" color="secondary">
          <Trans id="settings.organization.invoicing.companies.invoice-data.registration-id">
            Registration ID: {invoiceData.id.value} ({invoiceData.id.type})
          </Trans>
        </Paragraph>
      )}
      {addressLines.length > 0 && (
        <Paragraph size="200" color="secondary">
          <Trans id="settings.organization.invoicing.companies.invoice-data.address">
            Address: {addressLines.join(', ')}
          </Trans>
        </Paragraph>
      )}
      {invoiceData.website && (
        <Paragraph size="200" color="secondary">
          <Trans id="settings.organization.invoicing.companies.invoice-data.website">
            Website: {invoiceData.website}
          </Trans>
        </Paragraph>
      )}
      {invoiceData.vatNumber && (
        <Paragraph size="200" color="secondary">
          <Trans id="settings.organization.invoicing.companies.invoice-data.vat-number">
            VAT number: {invoiceData.vatNumber}
          </Trans>
        </Paragraph>
      )}
      {invoiceData.shareCapital && (
        <Paragraph size="200" color="secondary">
          <Trans id="settings.organization.invoicing.companies.invoice-data.share-capital">
            Share capital:{' '}
            {formatCurrency(
              invoiceData.shareCapital.amount * 100,
              invoiceData.shareCapital.currency
            )}
          </Trans>
        </Paragraph>
      )}
    </Stack>
  );
};
